import axios from '@/libs/api.request'

export const saveClient = async (that, data) => {
    var res = await axios.request({
        url: '/shop/client/saveClient',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const getFollowList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/client/getFollowList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const saveIntroduceClient = async (that, data) => {
    var res = await axios.request({
        url: '/shop/client/saveIntroduceClient',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const addClient = async (that, data) => {
    var res = await axios.request({
        url: '/shop/client/addClient',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const searchCustomer = async (that, data) => {
    var res = await axios.request({
        url: '/shop/client/searchCustomer',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const savePolicy = async (that, data) => {
    var res = await axios.request({
        url: '/shop/client/savePolicy',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const saveCreditCard = async (that, data) => {
    var res = await axios.request({
        url: '/shop/client/saveCreditCard',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const saveDebt = async (that, data) => {
    var res = await axios.request({
        url: '/shop/client/saveDebt',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const addVisit = async (that, data) => {
    var res = await axios.request({
        url: '/shop/client/addVisit',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const getClient = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/client/getClient',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const getClientRecord = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/client/getClientRecord',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const addClientTag = async (that, data) => {
    var res = await axios.request({
        url: '/shop/client/addClientTag',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const addContactTag = async (that, data) => {
    var res = await axios.request({
        url: '/shop/client/addContactTag',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const addRemark = async (that, data) => {
    var res = await axios.request({
        url: '/shop/client/addRemark',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const lookPhone = async (that, data) => {
    var res = await axios.request({
        url: '/shop/client/lookPhone',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const sendOrderNotice = async (that, data) => {
    var res = await axios.request({
        url: '/shop/client/sendOrderNotice',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const sendOrderNoticeNew = async (that, data) => {
    var res = await axios.request({
        url: '/shop/client/sendOrderNoticeNew',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const saveFollow = async (that, data) => {
    var res = await axios.request({
        url: '/shop/client/saveFollow',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const saveComment = async (that, data) => {
    var res = await axios.request({
        url: '/shop/client/saveComment',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const cancelTag = async (that, data) => {
    var res = await axios.request({
        url: '/shop/client/cancelTag',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const getList = async (that, data) => {
    // 去掉多余参数
    const { datas,columns,ruleValidate,shopList,userList,mediumCodeIdList,mediumList,cityList,cityData,announceImg,countDataImg, ...rest } = data;
    data = rest;

    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }


    var res = await axios.request({
        url: '/shop/client/getList',
        data,
        method: 'post'
    })
    res = res.data;

    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const getClickList = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }


    var res = await axios.request({
        url: '/shop/client/getClickList',
        data,
        method: 'post'
    })
    res = res.data;

    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const getSignList = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/client/getSignList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const getLoanList = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/client/getLoanList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const getClickSignList = async (that, data) => {
    var res = await axios.request({
        url: '/shop/client/getClickSignList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const addSea = async (that, data) => {
    var res = await axios.request({
        url: '/shop/client/addSea',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const addPool = async (that, data) => {
    var res = await axios.request({
        url: '/shop/client/addPool',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const addToMyClient = async (that, data) => {
    var res = await axios.request({
        url: '/shop/client/addToMyClient',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}

export const allUnlock = async (that, data) => {
    var res = await axios.request({
        url: '/shop/client/allUnlock',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}

//软删除签约合同
export const delContract = async (that, data) => {
    var res = await axios.request({
        url: '/shop/client/delContract',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}

//软删除进件
export const delLoan = async (that, data) => {
    var res = await axios.request({
        url: '/shop/client/delLoan',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}

export const lock = async (that, data) => {
    var res = await axios.request({
        url: '/shop/client/lock',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const giveOut = async (that, data) => {
    var res = await axios.request({
        url: '/shop/client/giveOut',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const transferUser = async (that, data) => {
    var res = await axios.request({
        url: '/shop/client/transferUser',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const getCount = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/client/getCount',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const getHistoryList = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/client/getHistoryList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const eraseFollow = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/client/eraseFollow',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const getClientLoan = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/client/getClientLoan',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const addEmergencyTag = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/client/addEmergencyTag',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const delClient = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/client/delClient',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const addFile = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/client/addFile',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}

export const getFileList = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/client/getFileList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const delFile = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/client/delFile',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const getHelpLoanList = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/client/getHelpLoanList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const startToWord = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/client/startToWord',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}


